'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propAliases = exports.propNames = exports.propTypes = exports.transform = exports.text = exports.spacing = exports.position = exports.overflow = exports.opacity = exports.list = exports.layout = exports.interaction = exports.flex = exports.dimensions = exports.boxShadow = exports.borders = exports.borderRadius = exports.background = exports.css = exports.splitBoxProps = exports.splitProps = exports.default = undefined;

var _glamor = require('glamor');

Object.defineProperty(exports, 'css', {
  enumerable: true,
  get: function get() {
    return _glamor.css;
  }
});

var _enhancers = require('./enhancers');

Object.defineProperty(exports, 'background', {
  enumerable: true,
  get: function get() {
    return _enhancers.background;
  }
});
Object.defineProperty(exports, 'borderRadius', {
  enumerable: true,
  get: function get() {
    return _enhancers.borderRadius;
  }
});
Object.defineProperty(exports, 'borders', {
  enumerable: true,
  get: function get() {
    return _enhancers.borders;
  }
});
Object.defineProperty(exports, 'boxShadow', {
  enumerable: true,
  get: function get() {
    return _enhancers.boxShadow;
  }
});
Object.defineProperty(exports, 'dimensions', {
  enumerable: true,
  get: function get() {
    return _enhancers.dimensions;
  }
});
Object.defineProperty(exports, 'flex', {
  enumerable: true,
  get: function get() {
    return _enhancers.flex;
  }
});
Object.defineProperty(exports, 'interaction', {
  enumerable: true,
  get: function get() {
    return _enhancers.interaction;
  }
});
Object.defineProperty(exports, 'layout', {
  enumerable: true,
  get: function get() {
    return _enhancers.layout;
  }
});
Object.defineProperty(exports, 'list', {
  enumerable: true,
  get: function get() {
    return _enhancers.list;
  }
});
Object.defineProperty(exports, 'opacity', {
  enumerable: true,
  get: function get() {
    return _enhancers.opacity;
  }
});
Object.defineProperty(exports, 'overflow', {
  enumerable: true,
  get: function get() {
    return _enhancers.overflow;
  }
});
Object.defineProperty(exports, 'position', {
  enumerable: true,
  get: function get() {
    return _enhancers.position;
  }
});
Object.defineProperty(exports, 'spacing', {
  enumerable: true,
  get: function get() {
    return _enhancers.spacing;
  }
});
Object.defineProperty(exports, 'text', {
  enumerable: true,
  get: function get() {
    return _enhancers.text;
  }
});
Object.defineProperty(exports, 'transform', {
  enumerable: true,
  get: function get() {
    return _enhancers.transform;
  }
});
Object.defineProperty(exports, 'propTypes', {
  enumerable: true,
  get: function get() {
    return _enhancers.propTypes;
  }
});
Object.defineProperty(exports, 'propNames', {
  enumerable: true,
  get: function get() {
    return _enhancers.propNames;
  }
});
Object.defineProperty(exports, 'propAliases', {
  enumerable: true,
  get: function get() {
    return _enhancers.propAliases;
  }
});
Object.defineProperty(exports, 'propEnhancers', {
  enumerable: true,
  get: function get() {
    return _enhancers.propEnhancers;
  }
});
exports.hydrate = hydrate;
exports.extractStyles = extractStyles;
exports.clearStyles = clearStyles;

var _cache = require('./cache');

var cache = _interopRequireWildcard(_cache);

var _styles = require('./styles');

var styles = _interopRequireWildcard(_styles);

var _box = require('./box');

var _box2 = _interopRequireDefault(_box);

var _splitProps2 = require('./utils/split-props');

var _splitProps3 = _interopRequireDefault(_splitProps2);

var _splitBoxProps2 = require('./utils/split-box-props');

var _splitBoxProps3 = _interopRequireDefault(_splitBoxProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = _box2.default;
exports.splitProps = _splitProps3.default;
exports.splitBoxProps = _splitBoxProps3.default;
function hydrate(entries) {
  cache.hydrate(entries);
}

function extractStyles() {
  var output = {
    cache: cache.entries(),
    styles: styles.getAll()
  };
  clearStyles();
  return output;
}

function clearStyles() {
  cache.clear();
  styles.clear();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/index.js
// module id = 14
// module chunks = 0